import * as React from 'react'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import Typography from '../components/Typography'
import ChurchOutlinedIcon from '@mui/icons-material/ChurchOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';

const item = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  px: 5,
}

function ProductValues() {
    return (
        <Box
        component="section"
        sx={{ display: 'flex', overflow: 'hidden', bgcolor: 'secondary.light' }}
        >
            <Container sx={{ mt: 15, mb: 30, display: 'flex', position: 'relative' }}>
                <Box
                    component="img"
                    src="/static/themes/onepirate/productCurvyLines.png"
                    alt="curvy lines"
                    sx={{ pointerEvents: 'none', position: 'absolute', top: -180 }}
                    />
                <Grid container spacing={5}>
                    <Grid item xs={12} md={4}>
                        <Box sx={item}>
                            <AutoStoriesOutlinedIcon sx={{ fontSize: 48 }}/>
                            <Typography variant="h6" sx={{ my: 5 }}>Worship</Typography>
                            <Typography variant="h5">
                                { 'We seek to worship God with reverence, dignity, diversity and within our strong musical tradition. Prayer and listening to God are essential apects of our understanding of worship.' }
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box sx={item}>
                            <PeopleOutlinedIcon sx={{ fontSize: 48 }}/>
                            <Typography variant="h6" sx={{ my: 5 }}>Community Engagement</Typography>
                            <Typography variant="h5">
                                { 'We seek to strengthen our engagement with the community by hosting regular events, such as open houses, cultural celebrations, and interfaith dialogues, to build bridges and promote mutual understanding.' }
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box sx={item}>
                            <ChurchOutlinedIcon sx={{ fontSize: 48 }}/>
                            <Typography variant="h6" sx={{ my: 5 }}>Spiritual Development</Typography>
                            <Typography variant="h5">
                                { 'We aim to be a leading center for spiritual development, offering diverse and enriching programs that inspire individuals to deepen their faith, explore their spiritual gifts, and live out their Christian values.' }
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    )
}

export default ProductValues
